// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

export function ChevronLeft() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Chevron Left"
      role="img"
    >
      <title>Chevron Left</title>
      <path
        d="M8.92155 11.9954L16.46 19.5387L14.9977 21L5.99798 11.9945L14.9982 3L16.4595 4.46225L8.92155 11.9954Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronRight() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Chevron Right"
    >
      <title>Chevron Right</title>
      <path
        d="M15.0784 12.0046L7.54 4.46132L9.00225 3L18.002 12.0055L9.00178 21L7.54047 19.5377L15.0784 12.0046Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronUp() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Chevron Up"
      role="img"
    >
      <title>Chevron Up</title>
      <path
        d="M12.0046 8.92154L4.46132 16.46L3 14.9977L12.0055 5.99797L21 14.9982L19.5377 16.4595L12.0046 8.92154Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronDown(props: { title?: string }) {
  const { title = 'Chevron Down' } = props;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      role="img"
    >
      <title>{title}</title>
      <path
        d="M11.9954 15.0785L19.5387 7.54001L21 9.00226L11.9945 18.002L3 9.00179L4.46225 7.54047L11.9954 15.0785Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronLeftThin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Chevron Left"
      role="img"
    >
      <title>Chevron Left</title>
      <path
        d="M7.52511 12.0051L15.7627 3.76231L14.9999 3L6 12.0056L15.0001 21L15.7624 20.2372L7.52511 12.0051Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronRightThin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Chevron Right"
    >
      <title>Chevron Right</title>
      <path
        d="M16.4749 12.0051L8.23732 3.76231L9.00012 3L18 12.0056L8.99988 21L8.23757 20.2372L16.4749 12.0051Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronUpThin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Chevron Up"
      role="img"
    >
      <title>Chevron Up</title>
      <path
        d="M12.0051 7.52511L3.76231 15.7627L3 14.9999L12.0056 6L21 15.0001L20.2372 15.7624L12.0051 7.52511Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronDownThin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Chevron Down"
    >
      <title>Chevron Down</title>
      <path
        d="M11.9949 16.4749L20.2377 8.23732L21 9.00012L11.9944 18L3 8.99988L3.7628 8.23757L11.9949 16.4749Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronlineLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Chevron Left"
    >
      <title>Chevron Left</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3H5V21H7V3ZM19.46 19.5387L11.9216 11.9954L19.4595 4.46225L17.9982 3L8.99798 11.9945L17.9977 21L19.46 19.5387Z"
        fill="black"
      />
    </svg>
  );
}

export function ChevronlineRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Chevron Right"
    >
      <title>Chevron Right</title>
      <rect width="24" height="24" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21H19L19 3H17L17 21ZM4.54 4.46132L12.0784 12.0046L4.54047 19.5377L6.00179 21L15.002 12.0055L6.00225 3L4.54 4.46132Z"
        fill="black"
      />
    </svg>
  );
}
